import React from "react";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    LineElement,
    PointElement,
    Title,
    Tooltip,
    Legend,
    Filler,
} from "chart.js";

import { Bar, Line } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    LineElement,
    PointElement,
    Title,
    Tooltip,
    Legend,
    Filler,
    ChartDataLabels
);

export default function LikelihoodToSwitchAreaStackedChart() {
    const likelihoodQueryResults1 = [
        // July 2026
        {
            likelihood_to_switch_lic: "Very unlikely",
            tot_val: 20,
            month: 7,
            year: 2026,
        },
        {
            likelihood_to_switch_lic: "Unlikely",
            tot_val: 30,
            month: 7,
            year: 2026,
        },
        {
            likelihood_to_switch_lic: "Likely",
            tot_val: 35,
            month: 7,
            year: 2026,
        },
        {
            likelihood_to_switch_lic: "Very likely",
            tot_val: 15,
            month: 7,
            year: 2026,
        },

        // August 2026
        {
            likelihood_to_switch_lic: "Very unlikely",
            tot_val: 15,
            month: 8,
            year: 2026,
        },
        {
            likelihood_to_switch_lic: "Unlikely",
            tot_val: 25,
            month: 8,
            year: 2026,
        },
        {
            likelihood_to_switch_lic: "Likely",
            tot_val: 40,
            month: 8,
            year: 2026,
        },
        {
            likelihood_to_switch_lic: "Very likely",
            tot_val: 20,
            month: 8,
            year: 2026,
        },

        // September 2026
        {
            likelihood_to_switch_lic: "Very unlikely",
            tot_val: 10,
            month: 9,
            year: 2026,
        },
        {
            likelihood_to_switch_lic: "Unlikely",
            tot_val: 20,
            month: 9,
            year: 2026,
        },
        {
            likelihood_to_switch_lic: "Likely",
            tot_val: 45,
            month: 9,
            year: 2026,
        },
        {
            likelihood_to_switch_lic: "Very likely",
            tot_val: 25,
            month: 9,
            year: 2026,
        },

        // October 2026
        {
            likelihood_to_switch_lic: "Very unlikely",
            tot_val: 12,
            month: 10,
            year: 2026,
        },
        {
            likelihood_to_switch_lic: "Unlikely",
            tot_val: 18,
            month: 10,
            year: 2026,
        },
        {
            likelihood_to_switch_lic: "Likely",
            tot_val: 42,
            month: 10,
            year: 2026,
        },
        {
            likelihood_to_switch_lic: "Very likely",
            tot_val: 28,
            month: 10,
            year: 2026,
        },
    ];
    const likelihoodQueryResults = [
            {
                "brandId": 6,
                "brand_name": "LIC",
                "likelihood_to_switch_lic": "Likely",
                "tot_val": "50.00",
                "month": 9,
                "year": 2026
            },
            {
                "brandId": 6,
                "brand_name": "LIC",
                "likelihood_to_switch_lic": "Very likely",
                "tot_val": "50.00",
                "month": 9,
                "year": 2026
            }
        ]
    if ( !Array.isArray(likelihoodQueryResults) || likelihoodQueryResults.length === 0 ) {
        return (
            <div className="App h-w-100 white-color">
                <p className="text-black ms-4"> No data available!No data available! </p>
            </div>
        );
    }
    // ============================================================
    // MONTH NAMES
    // ============================================================

    const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
    ];

    // ============================================================
    // GET LATEST MONTH
    // ============================================================
    const sortedData = [...likelihoodQueryResults].sort(
        (a, b) =>
            new Date(
                Number(b.year),
                Number(b.month) - 1
            ) -
            new Date(
                Number(a.year),
                Number(a.month) - 1
            )
    );

    const latestMonth = Number(sortedData[0]?.month);
    const latestYear = Number(sortedData[0]?.year);

    const currentMonthData = likelihoodQueryResults.filter(
        (item) =>
            Number(item.month) === latestMonth &&
            Number(item.year) === latestYear
    );

    const labels = currentMonthData.map(
        (item) => item.likelihood_to_switch_lic
    );

    const values = currentMonthData.map(
        (item) => Number(item.tot_val) || 0
    );

    const data = {
        labels: labels,

        datasets: [
            {
                label: "Likelihood to Switch",

                data: values,

                backgroundColor: "#f06b22",

                borderColor: "#f06b22",

                borderWidth: 1,

                borderRadius: 10,

                borderSkipped: false,

                barPercentage: 0.5,

                categoryPercentage: 0.7,

                datalabels: {
                    color: (context) => {
                        const value =
                            context.dataset.data[
                                context.dataIndex
                            ];

                        return value === 0
                            ? "#313932"
                            : "#fff";
                    },

                    font: {
                        size:
                            window.innerWidth < 767
                                ? 10
                                : 12,

                        family:
                            "Graphik-Semibold, sans-serif",
                    },
                },
            },
        ],
    };

    // ============================================================
    // BAR CHART OPTIONS
    // ============================================================

    const options = {
        indexAxis: "y",

        responsive: true,

        maintainAspectRatio: false,

        scales: {
            x: {
                beginAtZero: true,

                grid: {
                    color: "#424242",
                    display: false,
                },

                ticks: {
                    display: false,

                    color: "#ffffff",

                    font: {
                        family:
                            "Graphik-Light, sans-serif",

                        size:
                            window.innerWidth > 767
                                ? 8
                                : 10,
                    },
                },

                border: {
                    display: false,
                },
            },

            y: {
                grid: {
                    color: "#424242",
                    display: false,
                },

                ticks: {
                    font: () => ({
                        size:
                            window.innerWidth < 1100
                                ? 10
                                : 15,

                        family:
                            "Graphik-Light, sans-serif",
                        weight: "500",
                        color: "rgb(49, 57, 50)",
                    }),
                    align: "center",
                    padding: 10,
                    crossAlign: "far",
                },
                border: {
                    display: false,
                },
                categoryPercentage: 1,
                barPercentage: 0.8,
            },
        },
        plugins: {
            legend: {
                display: false,
                labels: {
                    color: "#ffffff",
                    font: {
                        family:
                            "Graphik-Light, sans-serif",
                    },
                },
            },
            datalabels: {
                font: (context) => {
                    return {
                        size:
                            window.innerWidth < 1100
                                ? 10
                                : 15,
                        family:
                            "Graphik-Light, sans-serif",
                    };
                },
                color: "#ffffff",
                formatter: (value) =>
                    `${value}%`,
                align: (context) => {
                    const value =
                        context.dataset.data[
                            context.dataIndex
                        ];
                    return value <= 1 &&
                        value >= 0
                        ? "end"
                        : "start";
                },
                anchor: (context) => {
                    const value =
                        context.dataset.data[
                            context.dataIndex
                        ];
                    return value <= 1 &&
                        value >= 0
                        ? "end"
                        : "end";
                },
            },
            tooltip: {
                callbacks: {
                    title: function (tooltipItem) {
                        return tooltipItem[0].label;
                    },
                    label: function (tooltipItem) {
                        const value =
                            tooltipItem.raw;
                        const dataIndex =
                            tooltipItem.dataIndex;
                        const respondentCount =
                            currentMonthData[
                                dataIndex
                            ]?.tot_val ?? "N/A";
                        return `Likelihood to Switch: ${value}% | Count: ${respondentCount}`;
                    },
                },
                titleFont: {
                    family:
                        "Graphik-Light, sans-serif",
                    size: 12,
                },
                bodyFont: {
                    family:
                        "Graphik-Light, sans-serif",
                    size: 10,
                },
                footerFont: {
                    family:
                        "Graphik-Light, sans-serif",
                    size: 10,
                },
            },
        },
        layout: {
            padding: {
                top: 0,
                right: 20,
                bottom: 20,
                left: 12,
            },
        },
    };

    const monthKeys = [
        ...new Set(
            likelihoodQueryResults.map(
                (item) =>
                    `${Number(item.year)}-${String(
                        Number(item.month)
                    ).padStart(2, "0")}`
            )
        ),
    ].sort();

    const areaLabels = monthKeys.map((key) => {
        const [year, month] = key.split("-");
        return `${monthNames[Number(month) - 1]} ${year}`;
    });

    // const likelihoodCategories = [
    //     "Very unlikely",
    //     "Unlikely",
    //     "Likely",
    //     "Very likely",
    // ];
    const likelihoodCategories = [
        ...new Set(
            likelihoodQueryResults
                .map(item => item.likelihood_to_switch_lic)
                .filter(Boolean)
        )
    ];

    const areaDatasets = likelihoodCategories.map(
        (category) => {
            return {
                label: category,
                data: monthKeys.map((key) => {
                    const [year, month] =
                        key.split("-");
                    // Get all records for this month
                    const monthRecords =
                        likelihoodQueryResults.filter(
                            (item) =>
                                Number(item.year) ===
                                    Number(year) &&
                                Number(item.month) ===
                                    Number(month)
                        );
                    // Total responses for this month
                    const total =
                        monthRecords.reduce(
                            (sum, item) =>
                                sum +
                                (Number(
                                    item.tot_val
                                ) || 0),
                            0
                        );
                    // Current category
                    const categoryRecord =
                        monthRecords.find(
                            (item) =>
                                item.likelihood_to_switch_lic ===
                                category
                        );
                    const value =
                        Number(
                            categoryRecord?.tot_val
                        ) || 0;
                    // Convert count to percentage
                    return total > 0
                        ? Number(
                              (
                                  (value / total) *
                                  100
                              ).toFixed(2)
                          )
                        : 0;
                }),
                fill: true,
                tension: 0.3,
                pointRadius: 3,
                pointHoverRadius: 5,
                borderWidth: 1,
                backgroundColor:
                    category ===
                    "Very unlikely"
                        ? "rgba(49, 57, 50, 0.20)"
                        : category === "Unlikely"
                        ? "rgba(49, 57, 50, 0.35)"
                        : category === "Likely"
                        ? "rgba(240, 107, 34, 0.55)"
                        : "rgba(240, 107, 34, 0.85)",
                borderColor:
                    category ===
                    "Very unlikely"
                        ? "#313932"
                        : category === "Unlikely"
                        ? "#313932"
                        : "#f06b22",
            };
        }
    );

    const areaData = {
        labels: areaLabels,
        datasets: areaDatasets,
    };

    const areaOptions = {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
            mode: "index",
            intersect: false,
        },
        scales: {
            x: {
                stacked: true,
                grid: {
                    display: false,
                },
                border: {
                    display: false,
                },
                ticks: {
                    color: "#313932",
                    font: {
                        family:
                            "Graphik-Light, sans-serif",
                        size:
                            window.innerWidth < 1100
                                ? 10
                                : 12,
                    },
                },
            },
            y: {
                stacked: true,
                beginAtZero: true,
                max: 100,
                grid: {
                    display: false,
                },
                border: {
                    display: false,
                },
                ticks: {
                    color: "#313932",
                    callback: (value) =>
                        `${value}%`,
                    font: {
                        family:
                            "Graphik-Light, sans-serif",
                        size: 10,
                    },
                },
            },
        },
        plugins: {
            legend: {
                display: true,
                position: "bottom",
                labels: {
                    usePointStyle: true,
                    color: "#313932",
                    padding: 15,
                    font: {
                        family:
                            "Graphik-Light, sans-serif",
                        size: 11,
                    },
                },
            },
            datalabels: {
                display: false,
            },
            tooltip: {
                mode: "index",
                intersect: false,
                callbacks: {
                    label: function (context) {
                        return `${context.dataset.label}: ${context.raw}%`;
                    },
                },
                titleFont: {
                    family:
                        "Graphik-Light, sans-serif",
                    size: 12,
                },
                bodyFont: {
                    family:
                        "Graphik-Light, sans-serif",
                    size: 10,
                },
            },
        },
        layout: {
            padding: {
                top: 10,
                right: 20,
                bottom: 10,
                left: 10,
            },
        },
    };

    return (
        <div className="container-fluid">
            {monthKeys.length > 1 && (
                <div className="card mb-4">
                    <div className="card-body">
                        <h5 className="mb-3">
                            Likelihood to Switch Trend
                        </h5>
                        <div
                            className="App metricChart h-w-100"
                            style={{
                                height: "350px",
                            }}
                        >
                            <Line
                                data={areaData}
                                options={areaOptions}
                            />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}